/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';

import classes from './styles.module.scss';

export default function Subtitles({ videoRef, trackRef }) {
  const [activeCues, setActiveCues] = useState([]);

  // On every timeupdate, read active cues and store in state.
  useEffect(() => {
    const videoEl = videoRef.current;
    if (!videoEl) return;

    function onTimeUpdate() {
      const textTrack = trackRef.current.track;
      if (!textTrack) return;

      const cues = Array.from(textTrack.activeCues || []);
      // We’ll map each TextTrackCue to a simpler object: { text, startTime, endTime, line, position }
      const mapped = cues.map((cue) => ({
        id: cue.id || `${cue.startTime}-${cue.endTime}-${Math.random()}`,
        text: cue.text,
        line: cue.line, // usually a number or percentage string
        position: cue.position, // usually a number or percentage
        startTime: cue.startTime,
        endTime: cue.endTime,
      }));
      setActiveCues(mapped);
    }

    videoEl.addEventListener('timeupdate', onTimeUpdate);
    return () => {
      videoEl.removeEventListener('timeupdate', onTimeUpdate);
    };
  }, [trackRef, videoRef]);

  if (!activeCues?.[0]?.text) {
    return null;
  }

  return (
    <div className={classes.Subtitles}>
      <span>{activeCues[0].text}</span>
    </div>
  );
}
